import PropTypes from 'prop-types';
import {normalizeCurrency} from "../../../lib/utils/helpers";
import {isRus} from "../../../lib/utils/country";
import { t } from 'i18next';
import { useInjection } from 'brandi-react';
import { PayBlockModelStoreToken } from 'components/common/PayBlock/models/PayBlockModel/index.model';
import { categorizationNumber } from "../../../lib/utils/helpers/categorizationNumber"

const getPrice = (v) => {
    if (v === undefined) {
        return '';
    }

    return v;
}

const PriceBlock = ({hasPaid, oldPrice, price, entity, currencies}) => {
    const paidEn = isRus ? '': 'paid_en'

    const payBlockModel = useInjection(PayBlockModelStoreToken);
    const successApply = payBlockModel.isCertSuccessApply() || payBlockModel.isPromoSuccessApply();
    const currency = normalizeCurrency(entity?.price_currency, currencies) || '';

    return (
        <div className={hasPaid ? `price-info paid ${paidEn}` :  "abonement__price-info price-info"}>
            <div className="price-left-col">
                <div className="abonement__card-label price-label card-label">{t('subscriptions.price')}</div>
                <div className="price-row">
                    <div className="abonement__price price mr-2">
                        {`${getPrice(categorizationNumber(price))} ${currency}`}
                    </div>
                    {oldPrice > price && successApply && <div className="old-price">{getPrice(oldPrice)} {currency}</div>}
                </div>
            </div>
        </div>
    )
}


PriceBlock.propTypes = {
    order: PropTypes.object,
    entity: PropTypes.object,
    currencies: PropTypes.array,
    certificateApplied: PropTypes.oneOfType([
        PropTypes.instanceOf(null),
        PropTypes.object,
    ]),
}
export default PriceBlock